import ContentHeader from './ContentHeader.js';

export default ContentHeader;
